// Generated by render-release-build.mjs; excluded from the input fingerprint.
export const RENDER_RELEASE = {"format":1,"fingerprint":"299c6e9ef6b1149322a878620280aff2b2b58f6b034f5d8b000c63564f90a614"} as const;
